import React, { useState } from "react";
import { SafButton, SafDialog, SafAlert } from "@saffron/core-components/react";
import SafTextComp from "./Saftext"; // Ensure the import path and component name are correct

const SafDialogbox = ({
  openAlertOptions,
  alertMessage,
  isOpen,
  handleOnClose,
  handleCancelClick,
  handleSubmit,
  dialogRef,
  dialogTitle,
}) => {
  const [form, setForm] = useState({
    diagramName: "",
    hyperlink: "",
    decisionRecordName: "",
    roadMapName: "",
  });
  const [errors, setErrors] = useState({});

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setForm((prevForm) => ({ ...prevForm, [name]: value }));
    setErrors((prevErrors) => ({ ...prevErrors, [name]: "" })); // Clear specific error when user starts typing
  };

  const validateForm = () => {
    const newErrors = {};
    const urlPattern = new RegExp(
      "^(https?:\\/\\/)?" + // protocol
        "((([a-zA-Z0-9$_.+!*'(),;?&=-]|%[0-9a-fA-F]{2}){1,64})@)?" + // username:password
        "((([a-zA-Z0-9-]{1,63}\\.){1,125}[a-zA-Z]{2,63})|" + // domain
        "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ipv4
        "(\\:\\d{1,5})?" + // port
        "(\\/[-a-zA-Z0-9%_.~+]*)*" + // path
        "(\\?[;&a-zA-Z0-9%_.~+=-]*)?" + // query string
        "(\\#[-a-zA-Z0-9_]*)?$",
      "i"
    );
    if (!form.diagramName && dialogTitle === "Add Diagram") {
      newErrors.diagramName = "Diagram Name is required";
    }
    if (!form.decisionRecordName && dialogTitle === "Add Decision Record") {
      console.log("Decision Record Name is required");
      newErrors.decisionRecordName = "Decision Record Name is required";
    }
    if (!form.roadMapName && dialogTitle === "Add Application Road Map") {
      newErrors.roadMapName = "Road Map Name is required";
    }
    if (!form.hyperlink) {
      console.log("Hyperlink is required");
      newErrors.hyperlink = "Hyperlink is required";
    } else if (!urlPattern.test(form.hyperlink)) {
      console.log("Invalid hyperlink format");
      newErrors.hyperlink = "Invalid hyperlink format";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const onSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      let updatedForm = { ...form };
      if (
        updatedForm.hyperlink &&
        !/^https?:\/\//i.test(updatedForm.hyperlink)
      ) {
        updatedForm.hyperlink = `http://${updatedForm.hyperlink}`;
      }
      handleSubmit(updatedForm);
    }
  };
  return (
    <div>
      {openAlertOptions && (
        <SafAlert
          appearance={openAlertOptions[1]}
          alertType={openAlertOptions[0]}
          iconAriaLabel="icon aria label"
          closeAriaLabel="Close"
          onClose={handleCancelClick}
        >
          {alertMessage}
        </SafAlert>
      )}
      <SafDialog
        ref={dialogRef}
        id="button-dialog-overlay"
        modal={false}
        dialogTitle={dialogTitle}
        hidden={!isOpen}
        triggerId="button-dialog-trigger"
        isAlert="false"
        isHeader="true"
        // isFooter="true"
        noFocusTrap={false}
        onClose={handleOnClose}
      >
        {dialogTitle === "Add Diagram" && (
          <>
            <SafTextComp
              label="Diagram Name"
              name="diagramName"
              value={form.diagramName}
              validationMessage={errors}
              onChange={handleInputChange}
              error={errors.diagramName}
            />
            {errors.diagramName && (
              <p style={{ color: "red" }}>{errors.diagramName}</p>
            )}

            <SafTextComp
              invalid={!!errors.hyperlink}
              label="link"
              name="hyperlink"
              value={form.hyperlink}
              validationMessage={errors.hyperlink}
              onChange={handleInputChange}
            />
            {errors.hyperlink && (
              <p style={{ color: "red" }}>{errors.hyperlink}</p>
            )}
          </>
        )}

        {dialogTitle === "Add Decision Record" && (
          <>
            <SafTextComp
              invalid={!!errors.decisionRecordName}
              label="Decision Record Name"
              name="decisionRecordName"
              value={form.decisionRecordName}
              validationMessage={errors.decisionRecordName}
              onChange={handleInputChange}
            />
            {errors.decisionRecordName && (
              <p style={{ color: "red" }}>{errors.decisionRecordName}</p>
            )}
            <SafTextComp
              invalid={!!errors.hyperlink}
              label="link"
              name="hyperlink"
              value={form.hyperlink}
              validationMessage={errors.hyperlink}
              onChange={handleInputChange}
            />
            {errors.hyperlink && (
              <p style={{ color: "red" }}>{errors.hyperlink}</p>
            )}
          </>
        )}

        {dialogTitle === "Add Application Road Map" && (
          <>
            <SafTextComp
              invalid={!!errors.roadMapName}
              label="Road Map Name"
              name="roadMapName"
              value={form.roadMapName}
              validationMessage={errors.roadMapName}
              onChange={handleInputChange}
            />
            {errors.roadMapName && (
              <p style={{ color: "red" }}>{errors.roadMapName}</p>
            )}

            <SafTextComp
              invalid={!!errors.hyperlink}
              label="link"
              name="hyperlink"
              value={form.hyperlink}
              validationMessage={errors.hyperlink}
              onChange={handleInputChange}
            />
            {errors.hyperlink && (
              <p style={{ color: "red" }}>{errors.hyperlink}</p>
            )}
          </>
        )}

        <br />
        <div>
          <SafButton appearance="secondary" onClick={handleOnClose}>
            Cancel
          </SafButton>
          &nbsp;&nbsp;
          <SafButton appearance="primary" onClick={onSubmit}>
            Save
          </SafButton>
        </div>
      </SafDialog>
    </div>
  );
};

export default SafDialogbox;
